import MenuItems from "./menu-items";
import environment from "../common/environment";

const SideMenu = MenuItems.extend({
  url: environment.getEndpoint("side-menu"),
});

export { SideMenu as default };
